import { Box } from '@mentimeter/ragnar-ui/box';
import {
  TitleSectionContainer,
  VotingMetaText,
  VotingTitle,
} from '../../ui/Components/VotingTitle';
import { QuestionImage } from '../../ui/Components/QuestionImage';
import { useAppSelector } from '../../redux-hooks';
import { paceModeSelector } from '../../selectors';
import { useTranslate } from '../../features/localization/Translate';
import type { ModuleComponentProps } from '../types';
import { VideoPlayer } from './VideoPlayer';

export function Content({ question }: ModuleComponentProps) {
  const {
    question: title,
    title_meta,
    image,
    question_video_embed_url,
  } = question;
  const translate = useTranslate();

  const pace = useAppSelector(paceModeSelector);
  const isAudiencePace = pace === 'audience';

  return (
    <TitleSectionContainer alignItems="center">
      {isAudiencePace && question_video_embed_url ? (
        <Box mb="space3" width="100%">
          <VideoPlayer videoUrl={question_video_embed_url} />
        </Box>
      ) : (
        image && (
          <QuestionImage
            crop={image.crop}
            largeImageUrl={image.presets.huge.url}
            mediumImageUrl={image.presets.medium.url}
            altText={image.alt_description}
            translateFn={translate}
            mb="space3"
          />
        )
      )}
      <VotingMetaText meta={title_meta} />
      <VotingTitle title={title} fontSize="100" lineHeight="relaxed" />
    </TitleSectionContainer>
  );
}
